<template>
  <Transition>
    <Info v-show="show" :title="item.title" :text="item.description"></Info>
  </Transition>
</template>

<script setup lang="ts">
import Info from '@/components/InfoDialogue.vue'
import type { HintItem } from '@/questionnaire/types'
import { onMounted, ref } from 'vue'

defineProps<{ item: HintItem }>()
const show = ref(false)
onMounted(() => {
  setTimeout(() => {
    show.value = true
  }, 2000)
})
</script>

<style>
.v-enter-active,
.v-leave-active {
  transition: opacity 1s ease;
}

.v-enter-from,
.v-leave-to {
  opacity: 0;
}
</style>
